export default {
  GREET: 'Selamat Datang',
  QUESTION: 'Mau kirim barang kemana hari ini?',
  ORIGIN_LOC: 'Lokasi Asal',
  DESTINATION_LOC: 'Lokasi Akhir',
  ERROR_LOCATION: 'Harap mengisi lokasi dengan benar',
  CREATE_NEW_ORDER: 'Buat Pesanan Baru',
  DESC_ORDER: 'Ringkasan Pesanan',
};
